import React from "react";
import { Box, Divider, Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Translate as T } from "react-localize-redux";
import theme from "../../theme";

const useStyles = makeStyles(() => ({
  paperBox: {
    borderColor: theme.palette.grey["500"],
    borderRadius: 4,
  },
  dividerLine: { backgroundColor: theme.palette.grey["500"] },
  titleBox: {
    display: "flex",
    justifyContent: "center",
    position: "relative",
    top: -12,
  },
  titleText: {
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
    paddingLeft: 8,
    paddingRight: 8,
  },
  fullWidth: {
    width: "100%",
  },
}));

interface FastPaymentBoxProps {
  enableFastPay: boolean;
}

export const FastPaymentBox = (props: FastPaymentBoxProps) => {
  const classes = useStyles();

  return (
    <Box
      className={classes.fullWidth}
      style={{ display: props.enableFastPay ? "block" : "none" }}
    >
      <Box pt={4} pb={1}>
        <Paper variant="outlined" className={classes.paperBox}>
          <Box className={classes.titleBox}>
            <Typography variant="body1" className={classes.titleText}>
              <T id={"card.fastPaymentTitle"} />
            </Typography>
          </Box>
          <Box display="flex" justifyContent="center" mt={1} mb={3}>
            <div id="kushki-apple-pay-button" />
          </Box>
        </Paper>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        pt={1}
        pb={1}
        className={classes.fullWidth}
      >
        <Box flex={1}>
          <Divider className={classes.dividerLine} />
        </Box>
        <Box px={2}>
          <Typography variant="body1" color="textSecondary">
            <T id={"card.fastPaymentOptional"} />
          </Typography>
        </Box>
        <Box flex={1}>
          <Divider className={classes.dividerLine} />
        </Box>
      </Box>
    </Box>
  );
};
